import { gql } from 'graphql-request'

export const DeleteSpeciGql = gql`
  mutation deleteSpeci($speciId: UUID!) {
    deleteSpeci(request: { speciId: $speciId }) {
      errorMessage
      success
    }
  }
`
